<template>

   <v-flex pb-0 pt-1 v-bind="$attrs" xs12>
      <v-autocomplete :hide-no-data="!allowNew" :item-text="displayField"
                      :item-value="displayKey" :items="items" :loading="isLoading"
                      :placeholder="pholder" :rules="validationRules" :search-input.sync="searchString"
                      :value="selectedKey" @blur="onBlur" @focus="onFocus"
                      dense box class="clean-style"
                      no-filter
                      ref="autocomplete"
                      return-masked-value
                      return-object
                      v-bind="$attrs"
                      v-on="listeners"
                      validate-on-blur>

         <template slot="no-data" v-if="allowNew">
            <v-layout @click.stop.prevent="onNewRecord" align-center class="pa-3" row wrap>
               <v-flex xs11>
                  {{`${$t('appMsg.create')} ${(searchString) ? searchString : $t('appMsg.new')}`}}
               </v-flex>

               <v-flex xs1>
                  <v-btn :class="{'disabled': $attrs.disabled}" @click.stop.prevent="onNewRecord" color="primary" dark
                         icon small
                         style="margin: 0;">
                     <v-icon small>fas fa-plus</v-icon>
                  </v-btn>
               </v-flex>
            </v-layout>
         </template>

         <!-- Pass on all named slots -->
         <slot :name="slot" :slot="slot" v-for="slot in Object.keys($slots).filter(s=> s!=='no-data')"/>

         <!-- Pass on all scoped slots -->
         <template :slot="slot"
                   slot-scope="scope" v-for="slot in Object.keys($scopedSlots).filter(s=> s !== 'item')">
            <slot :name="slot" v-bind="scope"/>
         </template>

         <template slot="item" slot-scope="{ index, item, parent }">
            <v-layout @click.stop.prevent="onNewRecord" align-center row v-if="item[displayKey] === null" wrap>
               <v-flex xs11>
                  {{`${$t('appMsg.create')} ${(searchString && !selectedKey) ? searchString : $t('appMsg.new')}`}}
               </v-flex>

               <v-flex xs1>
                  <v-btn :class="{'disabled': $attrs.disabled}" @click.stop.prevent="onNewRecord" color="primary" dark
                         icon small
                         style="margin: 0;">
                     <v-icon small>fas fa-plus</v-icon>
                  </v-btn>
               </v-flex>
            </v-layout>

            <v-layout align-center row v-else wrap>
               <v-flex xs11>
                  <slot :data="item" name="content">
                     {{item[displayField]}}
                  </slot>
               </v-flex>

               <v-flex v-show="allowEdit" xs1>
                  <v-btn @click.stop.prevent="onEditRecord(item)" icon small style="margin: 0;">
                     <v-icon small style="color: #585858 !important;">edit</v-icon>
                  </v-btn>
               </v-flex>
            </v-layout>

         </template>

      </v-autocomplete>

      <!--MODAL-->
      <v-dialog :max-width="modalWidth" content-class="modal-wrapper" lazy persistent v-model="modalShow">
         <component :data="modalData" :data-key="modalKey" :is="modalForm" :key="renderKey"
                    :obj="objRoot" :ref-data="refData"
                    @onClose="modalClose" @onDataSaved="modalDone" modal-mode/>
      </v-dialog>
   </v-flex>

</template>

<script>
   import debounce from 'lodash.debounce';
   import Rules from './validationRules';

   export default {
      name: 'a-autocomplete-field',

      props: {
         value: {
            required: false
         },
         autoTrigger: {
            type: Boolean,
            required: false,
            default: false
         },
         allowNew: {
            type: Boolean,
            required: false,
            default: false
         },
         allowEdit: {
            type: Boolean,
            required: false,
            default: false
         },
         floating: {
            type: Boolean,
            required: false,
            default: false
         },
         modalForm: {
            type: Function,
            required: false
         },
         modalWidth: {
            type: String,
            required: false,
            default: '450'
         },
         suggestions: {
            type: Array,
            required: false
         },
         displayKey: {
            type: String,
            required: false,
            default: 'id'
         },
         displayField: {
            required: false,
            default: 'name'
         },
         api: {
            type: String,
            required: false,
            default: 'dataService'
         },
         obj: {
            type: String,
            required: false
         },
         filterBy: {
            type: Object,
            required: false
         },
         refData: {
            required: false
         },
         validate: {
            type: String,
            required: false
         },
         minSearchLength: {
            type: Number,
            required: false,
            default: 3
         }
      },

      data () {
         return {
            isLoading: false,
            searchString: '',
            items: [],

            modalShow: false,
            renderKey: 0,

            selectedKey: null,
            selectedText: '',
            lastData: null,
            lastSearchString: '',
            lastFilterBy: null,

            modalData: null,
            modalKey: null

         };
      },

      watch: {
         searchString (newValue, oldValue) {
            if (newValue == null && oldValue) {
               //this.log('searchString - reset()', newValue, oldValue);
               this.reset();
            } else if (newValue && typeof newValue === 'string' && newValue.trim() !== this.lastSearchString && newValue !== this.selectedText) {
               this.debouncedSearch(newValue);
            }
         },
         value: {
            handler: function (newValue, oldValue) {
               if (newValue == null && oldValue) {
                  //this.log('value - reset()');
                  this.$nextTick(() => this.reset());
               } else if (newValue != null) {
                  //this.log('value - searchById()', newValue, this.selectedKey);
                  (newValue != this.selectedKey) && this.$nextTick(() => this.searchById(newValue));
               }
            },
            immediate: true
         },
         modalShow (val) {
            if (val) {
               this.renderKey = +new Date();
            }
         },
      },

      computed: {
         objRoot () {
            return this.obj.split('/')[0];
         },

         pholder () {
            let prop = this.placeholder;
            return (this.floating) ? (prop || '') : (prop || ' ');
         },

         listeners () {
            return {
               ...this.$listeners,
               input: (data) => {
                  if (data) {
                     this.selectedItem(JSON.parse(JSON.stringify(data)));
                  }
               }
            };
         },

         validationRules () {
            let rules = [];

            if (this.validate) {
               let rulesArray = this.validate.split(',');
               rulesArray.forEach(r => rules.push(Rules[r.trim()]));
            }

            return rules;
         }
      },

      methods: {
         log (...args) {
            console.log(this.obj + ' - ', ...args);
         },
         reset () {
            this.items = [];
            this.lastData = null;
            this.lastSearchString = '';
            this.selectedText = null;
            this.selectedKey = null;

            this.$emit('input', null);
         },

         needSearch (input) {
            if (input && typeof input === 'string' && input.length < this.minSearchLength) return false;
            return (this.filterBy && !this.$util.sameObject(this.lastFilterBy, this.filterBy)) ||
               !(input === this.lastSearchString && this.lastData);
         },

         getApiSuggestions (input) {
            let params = (this.filterBy) ? Object.assign({}, this.filterBy, { text: input }) : input;
            this.lastSearchString = input;
            this.lastFilterBy = JSON.parse(JSON.stringify(this.filterBy || {}));


            // console.log('getApiSuggestions', params);
            return this.$api[this.api].search(this.obj, params);
         },

         search (input) {
            input = (input && input === this.selectedText) ? this.lastSearchString : input;
            if (input) input = input.trim();

            if (this.suggestions && this.suggestions.length && !this.items) {
               // console.log(this.obj + ' - search from suggestions');
               this.items = JSON.parse(JSON.stringify(this.suggestions));
            } else if (this.api && this.obj && this.needSearch(input)) {
               this.isLoading = true;
               this.getApiSuggestions(input)
                  .then((data) => {
                     data = (data === null) ? [] : this.$util.objectCopy(data);
                     if (this.allowNew && data && data.length) {
                        let newRow = {};
                        newRow[this.displayKey] = null;
                        newRow[this.displayField] = '';
                        data.unshift(newRow);
                     }

                     this.lastData = JSON.stringify(data);
                     this.items = data;
                  })
                  .catch((err) => console.log('Autocomplete API ERROR: ', err))
                  .finally(() => this.isLoading = false);
            }

         },

         searchById (key) {
            let setSelected = (data) => {
               let keyData = data.filter(v => v[this.displayKey] === key);
               if (!keyData || !keyData.length) return false;

               this.lastData = JSON.stringify(data);

               if (this.allowNew && data && data.length) {
                  let newRow = {};
                  newRow[this.displayKey] = null;
                  newRow[this.displayField] = '';
                  data.unshift(newRow);
               }

               //this.log('keyData:', keyData[0]);

               this.items = data;
               this.selectedText = keyData[0][this.displayField];
               this.selectedKey = key;

               this.$emit('onSelect', this.$util.objectCopy(keyData[0]));

               return true;

            };

            if (this.items && this.items.length) {
               if (setSelected(this.items)) {
                  return;
               }
            }

            if (this.suggestions && this.suggestions.length) {
               //this.log('searchById - suggestions');
               if (setSelected(this.suggestions)) {
                  return;
               }
            }

            if (this.api && this.obj) {
               //this.log('searchById - API call');

               this.isLoading = true;
               let params = (this.autoTrigger) ? {} : { id: key };
               this.$api[this.api].search(this.obj, params)
                  .then((data) => {
                     data = (data === null) ? [] : data;
                     setSelected(this.$util.objectCopy(data));
                  })
                  .catch((err) => console.log('Autocomplete API ERROR: ', err))
                  .finally(() => this.isLoading = false);
            }

         },

         selectedItem (data) {
            //Changed via user selection
            //this.log('selectedItem');
            try {
               if (this.allowNew && !data[this.displayKey]) {
                  this.onNewRecord();
                  return;
               }
               
               this.selectedText = data[this.displayField];
               this.selectedKey = data[this.displayKey];
               this.$emit('input', data[this.displayKey]);
               this.$emit('onSelect', this.$util.objectCopy(data));
            } catch (err) {
               console.log(`DisplayField/DisplayKey properties are not set properly for autocomplete (obj: ${this.obj}) | ${err}`);
            }
         },

         onFocus () {
            if (this.autoTrigger && !this.selectedKey) {
               this.search(this.searchString || '');
            }
         },

         onBlur () {

         },

         onNewRecord () {
            this.newRecord();
            this.$refs.autocomplete.blur();
         },

         newRecord () {
            if (this.allowNew) {
               if (!this.searchString || this.selectedKey) {
                  this.modalData = null;
               } else {
                  this.modalData = {};
                  this.modalData[this.displayField] = this.searchString;
               }
               this.modalKey = null;
               this.modalShow = true;
            }
         },

         onEditRecord (data) {
            this.editRecord(data[this.displayKey]);
            this.$refs.autocomplete.blur();
         },

         async editRecord (key) {
            if (this.allowEdit) {
               this.modalData = await this.$api.dataService.getById(this.objRoot, key);
               this.modalKey = key;
               this.modalShow = true;
            }
         },

         modalDone (data) {
            let key = data[this.displayKey];
            if (data && key) {
               if (this.modalKey) { //means edit/update record
                  let obj = this.$util.getObject(this.items, { id: key });
                  if (obj) {
                     this.$util.updateObj(obj[0], data);
                     if (this.selectedKey === key) { //force input change
                        this.selectedText = data[this.displayField];
                        this.searchString = data[this.displayField];
                     }
                  }
               } else { //new record
                  this.items.push(data);
               }

               this.selectedItem(data);
            }

            this.modalShow = false;
            this.$refs.autocomplete.focus();

         },

         modalClose() {
            this.modalShow = false;
         }
      },

      created () {
         this.debouncedSearch = debounce(function () {
            this.search(this.searchString);
         }, 400);
      }
   };
</script>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/AAutocompleteField.vue